import { NativeAudio } from "@ionic-native/native-audio";
import { ServiceProvider } from "./../../providers/service/service";
import { TranslateService } from "@ngx-translate/core";
import { Storage } from "@ionic/storage";
import { MerchantRentalRentComfirmPage } from "./../merchant-rental-rent-comfirm/merchant-rental-rent-comfirm";
import { QRScanner, QRScannerStatus } from "@ionic-native/qr-scanner";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-merchant-rental-rent",
  templateUrl: "merchant-rental-rent.html",
})
export class MerchantRentalRentPage {
  scanSub: any;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private qrScanner: QRScanner,
    private loadingCtrl: LoadingController,
    private storage: Storage,
    private translateService: TranslateService,
    private services: ServiceProvider,
    private nativeAudio: NativeAudio
  ) {
    this.nativeAudio.preloadSimple("uniqueId1", "assets/sounds/qr.aac");
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    this.qrScanner
      .prepare()
      .then((status: QRScannerStatus) => {
        if (status.authorized) {
          // console.log('Camera Permission Given');
          this.scanSub = this.qrScanner.scan().subscribe((result: string) => {
            //  console.log('Scanned something', text);

            let loader = this.loadingCtrl.create({
              // content: "Loading Please Wait...",
              duration: 1000,
            });
            loader.present();

            this.storage.get("info").then((info) => {
              var text = JSON.parse(result);

              if (text.action == "rent") {
                if (text.plaza_id == info.team.plaza_id) {
                  this.nativeAudio.play("uniqueId1");
                  this.navCtrl.push(MerchantRentalRentComfirmPage, { result });
                } else {
                  this.translateService
                    .get("Invalid plaza.")
                    .subscribe((value) => {
                      this.services.presentToast(value);
                    });
                }
              } else {
                this.translateService
                  .get("Invalid value.")
                  .subscribe((value) => {
                    this.services.presentToast(value);
                  });
              }
            });

            this.qrScanner.hide();
            this.scanSub.unsubscribe();
          });

          this.qrScanner.show();
        } else if (status.denied) {
          console.log("Camera permission denied");
        } else {
          console.log("Permission denied for this runtime.");
        }
      })
      .catch((e: any) => console.log("Error is", e));
  }

  backPage() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/merchant-rental-rent/merchant-rental-rent.ts